import { ChartHistogramSeries, HistogramPoint } from "app/models/chartHistogram/chartHistogram";
import { AnalyticsParams, AnalyticsSeriesEnum, MediaAnalyticsApi } from "app/backend/mediaAnalyticsApi";
import { TimeConfig } from "app/utils/timeUtils";
import { ApiHistogramBin } from "app/backend/types";

export class ChartHistogramProvider {
  constructor(private mediaAnalytics: MediaAnalyticsApi) {}

  provide = async (
    timeConfig: TimeConfig,
    analyticsSeries: AnalyticsSeriesEnum[],
    params?: AnalyticsParams,
    binTransform?: (bin: ApiHistogramBin) => void
  ): Promise<ChartHistogramSeries[]> => {
    const histogram = await this.mediaAnalytics.getHistogram(timeConfig, analyticsSeries, params);
    //const histogram = require("app/backend/histogramMock.json");
    const bins = histogram.reports.overtime.histogram.bins;
    if (binTransform) {
      const bins = histogram.reports.overtime.histogram.bins;
      for (let i = 0; i < bins.length; i++) {
        binTransform(bins[i]);
      }
    }

    let histograms = [];

    for (const series of analyticsSeries) {
      const points: Map<number, HistogramPoint> = new Map();
      for (const bin of bins) {
        let timestampMilliseconds = bin.timestamp * 1000;
        // Backend returns the X timestamp as the beginning of the interval, but in a histogram it makes more sense to show
        // the end
        timestampMilliseconds += timeConfig.interval.milliseconds;
        let value: number = bin.series[series];

        points.set(timestampMilliseconds, new HistogramPoint(timestampMilliseconds, value));
      }
      histograms.push(new ChartHistogramSeries(series, points));
    }
    return histograms;
  };
}



// WEBPACK FOOTER //
// ./app/models/chartHistogram/chartHistogramProvider.ts